import {Component} from '@angular/core';
import {InputButtonIconType} from "../core/button/button.utils";
import {Router} from "@angular/router";
import {AuthenticationService} from "../../services/rest/authentication.service";
import {DashboardService} from "../../services/rest/dashboard.service";
import {Dashboard} from "../../dtos/dashboard/Dashboard";
import {DatePipe} from "@angular/common";
import {SelectItem} from "../../dtos/SelectItem";
import {EspService} from "../../services/rest/esp.service";

import {ModuleTypeService} from "../../services/rest/module-type.service";
import {ChipTypeService} from "../../services/rest/chip-type.service";
import {DisplayTypeService} from "../../services/rest/display-type.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss']
})
export class DashboardComponent {
  InputButtonIconType = InputButtonIconType;

  loading = true;
  dashboard: Dashboard;

  // ESP Web Tools
  selectedSoftwareType: string = null;
  selectedModuleTypeCode: string = null;
  selectedChipTypeCode: string = null;
  selectedDisplayTypeCode: string = null;

  manifestObjectUrl: string | null = null;

  softwareTypeOptions: SelectItem[] = [
    { name: 'INTERNAL', id: 'INTERNAL' },
    { name: 'INTEGRATION', id: 'INTEGRATION' },
    { name: 'PRODUCTION', id: 'PRODUCTION' },
    { name: 'BOOTLOADER', id: 'BOOTLOADER' },
    { name: 'PARTITIONS', id: 'PARTITIONS' },
    { name: 'OTA_DATA', id: 'OTA_DATA' }
  ];

  moduleTypeOptions: SelectItem[] = [];
  chipTypeOptions: SelectItem[] = [];
  displayTypeOptions: SelectItem[] = [];

  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              private dashboardService: DashboardService,
              private datePipe: DatePipe,
              private espService: EspService,
              private moduleTypeService: ModuleTypeService,
              private chipTypeService: ChipTypeService,
              private displayTypeService: DisplayTypeService) {
    this.getDashboard();
    this.loadOptions();
  }

  loadOptions() {
    this.moduleTypeService.getAll().subscribe(options => {
      this.moduleTypeOptions = options.map(o => ({ name: o.name, id: o.code }));
    });
    this.chipTypeService.getAll().subscribe(options => {
      this.chipTypeOptions = options.map(o => ({ name: o.name, id: o.code }));
    });
    this.displayTypeService.getAll().subscribe(options => {
      this.displayTypeOptions = options.map(o => ({ name: o.name, id: o.code }));
    });
  }

  getDashboard() {
    this.dashboardService.getDashboard().subscribe(
      resp => {
        this.dashboard = resp;
        this.loading = false;
      }
    );
  }

  onLogin() {
    this.router.navigate(['login']);
  }

  userLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }

  prepareInstall() {
    // Fetch manifest JSON and create a blob URL
    this.espService.getManifest(this.selectedSoftwareType, this.selectedModuleTypeCode, this.selectedChipTypeCode, this.selectedDisplayTypeCode).subscribe((data: any) => {
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      if (this.manifestObjectUrl) {
        URL.revokeObjectURL(this.manifestObjectUrl);
      }
      this.manifestObjectUrl = URL.createObjectURL(blob);
    });
  }

  isMobile(): boolean {
    // Regular expression to detect mobile devices by user agent string
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  }

}
